export const initHeatmap = (appId) => {
  if (location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      l.head.appendChild(t);
    })(window, document, 'clarity', 'script', appId);
  }
};
